function delayedPromise(response) {
  return new Promise(resolve => setTimeout(() => resolve(response), 250));
}

export function getSelectedDealerId() {
  return delayedPromise(1);
}
